import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { MethodStyleInterface } from '../interfaces';

export const METHOD_STYLE_TOKEN = new InjectionToken<GetMethodStyle>('MethodStyleToken');
export type GetMethodStyle = (eduContentBookId: number) => Observable<MethodStyleInterface>;
